import { ContactTagModel } from "../../../factories/contacts/models/contact-tag.model";

// Same limit as the server (TagNameRules.MaxLength).
export const TAG_NAME_MAX = 30;

const key = (name: string | null | undefined) =>
  (name || "").trim().toLowerCase();

/**
 * Why this tag name can't be saved, or "" when it can: empty / spaces only,
 * longer than 30 characters, or already used by another tag of the firm
 * (ignoring capital letters and spaces around the name).
 */
export const tagNameProblem = (
  name: string,
  tags: Pick<ContactTagModel, "id" | "tagName">[] | undefined,
  exceptId?: string,
): string => {
  const clean = name.trim();
  if (!clean) return "Enter a tag name.";
  if (clean.length > TAG_NAME_MAX)
    return `Tag names can be at most ${TAG_NAME_MAX} characters.`;
  const taken = (tags || []).some(
    (tag) => tag.id !== exceptId && key(tag.tagName) === key(clean),
  );
  return taken ? `A tag named "${clean}" already exists.` : "";
};

/** "First Last" of whoever created the tag, or "" (older tags have nobody). */
export const tagCreatorName = (
  createdByUser: ContactTagModel["createdByUser"],
): string => {
  const profile = createdByUser?.userProfile;
  const name = [profile?.firstName, profile?.lastName]
    .filter((part) => !!part && part.trim())
    .join(" ")
    .trim();
  return name || profile?.email || "";
};
